import globals from '../globals';

const contentstack = require('contentstack');

export default {
  created() {
    if (this.csTemplate && this.csEntryid && this.handleData && this.handleError) { this.getEntry(this.csTemplate, this.csEntryid, this.handleData, this.handleError); }
  },
  props: {
    csTemplate: {
      type: String,
    },
    csEntryid: {
      type: String,
      default: '',
    },
    csComponent: {
      type: String,
    },
  },
  data() {
    return {
      cs: {
        contentstack: {
          stackid: null,
          type: null,
          entry: null,
          vcomponent: null,
        },
      },
    };
  },
  methods: {
    getEntry(contentType, entryid, resolve, reject) {
      const data = new Promise(() => {
        if (globals.contentstack.api_key && globals.contentstack.access_token && globals.contentstack.environment) {
          // initializing contentstck sdk
          const Stack = contentstack.Stack({
            api_key: globals.contentstack.api_key,
            access_token: globals.contentstack.access_token,
            environment: globals.contentstack.environment,
            CachePolicy: contentstack.CachePolicy.IGNORE_CACHE,
          });
          // Query
          Stack.ContentType(contentType).Query()
            .addParam('entryid', entryid)
            // .includeReference('header', 'footer')
            .toJSON()
            .find()
            .then((result) => {
              if (result) {
                resolve(result[0][0]);
              } else {
                return reject('Internal Error');
              }
            }, error => reject('Internal Error'));
        } else {
          return reject('Please provide valid globals config parameters');
        }
      });
      return data;
    },
    handleData(data) {
      // console.log(data);
      // console.log('content.uid', this['content.uid']);
      this.cs = data;
      // eslint-disable-next-line no-new-func
      // const func = new Function('return this.content.uid;');
      // console.log('func', func.apply(this));
      // eslint-disable-next-line dot-notation
      // console.log('content.uid', this['content']['uid']);
    },
    handleError(error) {
      this.cs.error = error;
    },
    openEditor() {

    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/mixins/contentstack-mixin.js